import(/* webpackMode: "eager" */ "/app/nextjs/src/app/page.tsx");
